import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import useNotify from "../../unit/useNotify";
import PaperComponent from "../../unit/PaperComponent";

export default function CustomLoanSwitchAchDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const lastDate = recordProp?.lastDate;
  const accruedInterestAmount = recordProp?.accruedInterestAmount;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        label="Get Smart ACH"
        variant="contained"
        size="medium"
        color="warning"
        sx={{ marginLeft: "10px", width: "175px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="loan-witchach-dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xs"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `loans/actions/switchAch`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
            });
            console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Confirm Get Smart ACH
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">
              Switching to Smart ACH requires that borrower add and verify a
              functional bank account on Happy Mango as payment source. Click
              “Confirm” to send notification and instruction to borrower.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Confirm" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
